export const cleanUrlDuplicateSlashes = (url: string) => {
  if (!url || url.startsWith('http')) return url
  url = url.replace(/\/\/+/g, '/')
  if (url.charAt(0) !== '/' && url.charAt(0) !== '#') url = '/' + url
  return url
}
